export interface BlogPostMeta {
  slug: string;
  title: string;
  metaTitle?: string;
  description: string;
  image: {
    webp: string;
    fallback: string;
    alt: string;
    width: number;
    height: number;
  };
  datePublished: string;
  dateModified: string;
  ctaLabel?: string;
  keywords?: string[];
}

export const blogPosts: BlogPostMeta[] = [
  {
    slug: "counselling-online-lingua-italiana",
    title: "Counselling online in lingua italiana",
    description:
        "Scopri come il counselling online in italiano offre flessibilità, prima sessione gratuita e supporto ovunque ti trovi.",
    image: {
      webp: "/incontro-online-real.webp",
      fallback: "/incontro-online-real.jpg",
      alt: "Counselling online in lingua italiana",
      width: 700,
      height: 400,
    },
    datePublished: "2025-12-18",
    dateModified: "2025-12-18",
    ctaLabel: "Scopri di più",
    keywords: [
      "counselling online",
      "counselling online in italiano",
      "counselling online italiano",
      "counselling gratuito",
      "counselling gratuito online",
      "counselling ovunque nel mondo",
      "counselling in italiano",
      "counselling Ticino",
      "counselling Ticino in italiano",
      "counselling Svizzera",
      "counselling Svizzera in italiano",
      "counselling online Svizzera",
      "counselling online Ticino"
    ],
  },
  {
    slug: "psicologia-psicoterapia-counselling",
    title: "Counselling, Coaching, Psicologia e Psicoterapia: differenze essenziali per orientarsi",
    metaTitle: "Counselling, Coaching, Psicologia e Psicoterapia",
    description:
        "Comprendi le differenze tra counselling, coaching, psicologia e psicoterapia per scegliere il supporto più adatto alle tue esigenze.",
    image: {
      webp: "/blog-psicologia-counselling.webp",
      fallback: "/blog-psicologia-counselling.jpg",
      alt: "Counselling, Coaching, Psicologia e Psicoterapia",
      width: 1242,
      height: 844,
    },
    datePublished: "2024-12-01",
    dateModified: "2024-12-11",
    keywords: [
      "counselling",
      "counselling professionale",
      "counselling a Zurigo",
      "counselling Svizzera",
      "counselling Ticino",
      "counselling in italiano",
      "counselling italiano",
      "differenze counselling coaching psicologia psicoterapia",
      "Counselling", 
      "Coaching", 
      "Psicologia", 
      "Psicoterapia"
    ],
  },
];

export function findBlogPost(slug: string): BlogPostMeta | undefined {
  return blogPosts.find((post) => post.slug === slug);
}
